"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Hyperlink3: ['hyperlink-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.458,18.374,7.721,21.11a2.853,2.853,0,0,1-3.942,0l-.892-.891a2.787,2.787,0,0,1,0-3.941l5.8-5.8a2.789,2.789,0,0,1,3.942,0l.893.892A1,1,0,0,0,14.94,9.952l-.893-.892a4.791,4.791,0,0,0-6.771,0l-5.8,5.8a4.787,4.787,0,0,0,0,6.77l.892.891a4.785,4.785,0,0,0,6.771,0l2.736-2.735a1,1,0,1,0-1.414-1.415Z', 'M22.526,2.363l-.892-.892a4.8,4.8,0,0,0-6.77,0l-2.905,2.9a1,1,0,0,0,1.414,1.414l2.9-2.9a2.79,2.79,0,0,1,3.941,0l.893.893a2.786,2.786,0,0,1,0,3.942l-5.8,5.8a2.769,2.769,0,0,1-1.971.817h0a2.766,2.766,0,0,1-1.969-.816,1,1,0,1,0-1.415,1.412,4.751,4.751,0,0,0,3.384,1.4h0a4.752,4.752,0,0,0,3.385-1.4l5.8-5.8a4.786,4.786,0,0,0,0-6.771Z']],
  HyperlinkCircle: ['hyperlink-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.348,0A8.653,8.653,0,0,0,8.194,3.783,1,1,0,1,0,9.847,4.909a6.652,6.652,0,1,1-.736,6.062,1,1,0,1,0-1.875.7A8.653,8.653,0,1,0,15.348,0Z', 'M14.153,19.089a6.651,6.651,0,1,1,.82-5.821,1,1,0,1,0,1.9-.625,8.654,8.654,0,1,0-1.068,7.572,1,1,0,1,0-1.653-1.126Z']],
  Hyperlink1: ['hyperlink-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6,12a1,1,0,0,0,1,1h9.5a1,1,0,0,0,0-2H7A1,1,0,0,0,6,12Z', 'M8.2,14.722A3.458,3.458,0,0,1,6,15.5a3.5,3.5,0,0,1,0-7,3.46,3.46,0,0,1,2.2.779A1,1,0,0,0,9.458,7.722a5.5,5.5,0,1,0,0,8.556A1,1,0,0,0,8.2,14.722Z', 'M18,6.5a5.519,5.519,0,0,0-3.458,1.223A1,1,0,0,0,15.8,9.278,3.46,3.46,0,0,1,18,8.5a3.5,3.5,0,0,1,0,7,3.458,3.458,0,0,1-2.2-.777,1,1,0,0,0-1.258,1.556A5.5,5.5,0,1,0,18,6.5Z']],
  Attachment1: ['attachment-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A6.97,6.97,0,0,0,5.038,6.961v11.91a5.128,5.128,0,1,0,10.255,0V9.713a3.293,3.293,0,0,0-6.586,0V17.5a1,1,0,0,0,2,0V9.713a1.293,1.293,0,0,1,2.586,0v9.158a3.128,3.128,0,1,1-6.255,0V6.961a4.962,4.962,0,0,1,9.924,0V14.5a1,1,0,0,0,2,0V6.961A6.97,6.97,0,0,0,12,0Z']],
  Attachment: ['attachment', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.843,3.455a6.961,6.961,0,0,0-9.846,0L1.619,13.832a5.128,5.128,0,0,0,7.252,7.252L17.3,12.653A3.293,3.293,0,1,0,12.646,8L7.457,13.184A1,1,0,1,0,8.871,14.6L14.06,9.409a1.294,1.294,0,0,1,1.829,1.83L7.457,19.67a3.128,3.128,0,0,1-4.424-4.424L13.411,4.869a4.962,4.962,0,1,1,7.018,7.018L12.646,19.67a1,1,0,1,0,1.414,1.414L21.843,13.3a6.96,6.96,0,0,0,0-9.846Z']],
  LinkBroken: ['link-broken', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.727,5.283a1.016,1.016,0,0,0,1.414,0,1,1,0,0,0,0-1.414l-2-2A1,1,0,0,0,3.727,3.283Z', 'M9.5,4.5a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V3.5A1,1,0,0,0,9.5,4.5Z', 'M2.909,9h2.5a1,1,0,0,0,0-2h-2.5a1,1,0,0,0,0,2Z', 'M10.727,17.869l-3.4,3.4a2.57,2.57,0,0,1-3.535,0l-1.061-1.06a2.511,2.511,0,0,1,0-3.536l3.4-3.4a1,1,0,1,0-1.414-1.414l-3.4,3.4a4.51,4.51,0,0,0,0,6.364l1.061,1.06a4.509,4.509,0,0,0,6.363,0l3.4-3.4a1,1,0,1,0-1.414-1.414Z', 'M19.377,7h-4.5a1,1,0,1,0,0,2h4.5A2.7,2.7,0,0,1,22,11.576v2A2.576,2.576,0,0,1,19.353,16H14.877a1,1,0,0,0,0,2h4.476A4.544,4.544,0,0,0,24,13.576v-2A4.662,4.662,0,0,0,19.377,7Z']],
  LinkBroken2: ['link-broken-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,.5A4.505,4.505,0,0,0,7.5,5V8.134a1,1,0,0,0,2,0V5a2.5,2.5,0,0,1,5,0v5.5A2.5,2.5,0,0,1,12,13a1,1,0,0,0,0,2,4.5,4.5,0,0,0,4.5-4.5V5A4.505,4.505,0,0,0,12,.5Z', 'M15.5,15.634a1,1,0,0,0-1,1V19a2.5,2.5,0,0,1-5,0V14A2.5,2.5,0,0,1,12,11.5a1,1,0,0,0,0-2A4.505,4.505,0,0,0,7.5,14v5a4.5,4.5,0,0,0,9,0V16.634A1,1,0,0,0,15.5,15.634Z', 'M5.237,6.883l-1.3-.75a1,1,0,0,0-1,1.733l1.3.75a1,1,0,1,0,1-1.733Z', 'M4,12.5a1,1,0,0,0,0-2H2.5a1,1,0,0,0,0,2Z', 'M4.237,14.383l-1.3.75a1,1,0,0,0,1,1.733l1.3-.75a1,1,0,1,0-1-1.733Z', 'M19.264,8.749a1,1,0,0,0,.5-.133l1.3-.75a1,1,0,1,0-1-1.733l-1.3.75a1,1,0,0,0,.5,1.866Z', 'M21.5,10.5H20a1,1,0,0,0,0,2h1.5a1,1,0,0,0,0-2Z', 'M21.062,15.133l-1.3-.75a1,1,0,1,0-1,1.733l1.3.75a1,1,0,1,0,1-1.733Z']],
  Hyperlink: ['hyperlink', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.232,14.341a1,1,0,0,0-1.307.54.966.966,0,0,1-.219.326A.985.985,0,0,1,8,15.5H4a2,2,0,0,1-2-2v-3a2,2,0,0,1,2-2H8a.991.991,0,0,1,.708.294.972.972,0,0,1,.217.324,1,1,0,1,0,1.847-.767A3,3,0,0,0,8,6.5H4a4,4,0,0,0-4,4v3a4,4,0,0,0,4,4H8a3.007,3.007,0,0,0,2.772-1.85A1,1,0,0,0,10.232,14.341Z', 'M6,12a1,1,0,0,0,1,1H18a1,1,0,0,0,0-2H7A1,1,0,0,0,6,12Z', 'M20,6.5H16A3.006,3.006,0,0,0,13.228,8.35a1,1,0,1,0,1.847.767.976.976,0,0,1,.219-.326A.989.989,0,0,1,16,8.5h4a2,2,0,0,1,2,2v3a2,2,0,0,1-2,2H16a.987.987,0,0,1-.708-.294.962.962,0,0,1-.217-.324,1,1,0,1,0-1.847.768A3,3,0,0,0,16,17.5h4a4,4,0,0,0,4-4v-3A4,4,0,0,0,20,6.5Z']],
  Hyperlink2: ['hyperlink-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.406,14.905a1,1,0,0,0-.543,1.307,1,1,0,0,1-.217,1.09L8.818,20.131a2,2,0,0,1-2.828,0L3.868,18.01a2,2,0,0,1,0-2.829L6.7,12.353a1.013,1.013,0,0,1,1.091-.217,1,1,0,0,0,.763-1.849,3.034,3.034,0,0,0-3.268.652L2.454,13.767a4.006,4.006,0,0,0,0,5.657l2.122,2.121a4,4,0,0,0,5.656,0l2.829-2.828a3.008,3.008,0,0,0,.651-3.27A1,1,0,0,0,12.406,14.905Z', 'M7.757,16.241a1.011,1.011,0,0,0,1.414,0L16.95,8.463a1,1,0,0,0-1.414-1.414L7.757,14.827A1,1,0,0,0,7.757,16.241Z', 'M21.546,4.574,19.425,2.453a4.006,4.006,0,0,0-5.657,0L10.939,5.281a3.006,3.006,0,0,0-.651,3.269,1,1,0,1,0,1.849-.764A1,1,0,0,1,12.354,6.7l2.828-2.828a2,2,0,0,1,2.829,0l2.121,2.121a2,2,0,0,1,0,2.829L17.3,11.645a1.015,1.015,0,0,1-1.091.217,1,1,0,0,0-.765,1.849,3.026,3.026,0,0,0,3.27-.651l2.828-2.828A4.007,4.007,0,0,0,21.546,4.574Z']],
  LinkBroken1: ['link-broken-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,6.5H15a1,1,0,1,0,0,2h4a3,3,0,0,1,3,3v1a3,3,0,0,1-3,3H15a1,1,0,0,0,0,2h4a5.006,5.006,0,0,0,5-5v-1A5.006,5.006,0,0,0,19,6.5Z', 'M5,8.5H9a1,1,0,0,0,0-2H5a5.006,5.006,0,0,0-5,5v1a5.006,5.006,0,0,0,5,5H9a1,1,0,1,0,0-2H5a3,3,0,0,1-3-3v-1A3,3,0,0,1,5,8.5Z', 'M12,1a1,1,0,0,0-1,1V5a1,1,0,0,0,2,0V2A1,1,0,0,0,12,1Z', 'M15,5.493a1,1,0,0,0,.707-.287l1.5-1.5a1,1,0,1,0-1.414-1.414l-1.5,1.5A.994.994,0,0,0,15,5.493Z', 'M8.207,2.292A1,1,0,1,0,6.793,3.706l1.5,1.5a1.012,1.012,0,0,0,1.414,0,1,1,0,0,0,0-1.414Z', 'M12,18a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0V19A1,1,0,0,0,12,18Z', 'M15.707,18.792a1,1,0,0,0-1.414,1.414l1.5,1.5a1,1,0,1,0,1.414-1.414Z', 'M8.293,18.792l-1.5,1.5a1,1,0,0,0,1.414,1.414l1.5-1.5a1,1,0,0,0-1.414-1.414Z']]
};
exports["default"] = _default;